import { useEffect, useState } from "react";
import { toast } from "sonner";
import AppShell from "@/components/AppShell";
import { useAuth, ROLE_THEMES } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { api } from "@/lib/api";

export default function Responses() {
  const { user } = useAuth();
  const { t } = useI18n();
  const theme = user ? ROLE_THEMES[user.role] : ROLE_THEMES.farmer;
  const [dir, setDir] = useState("received");
  const [items, setItems] = useState([]);

  const load = () => api.get("/interests", { params: { direction: dir } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [dir]);

  const action = async (id, status) => {
    await api.post(`/interests/${id}/action`, { status });
    toast.success(`Marked ${status}`);
    load();
  };

  return (
    <AppShell>
      <div className="px-4 md:px-8 lg:px-12 py-8">
        <div className="text-xs uppercase tracking-[0.24em] text-gray-500">Interest & Responses</div>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight">{t("responses.title")}</h1>

        <div className="mt-6 inline-flex bg-white border border-gray-200 rounded-full p-1">
          {[{ k: "received", l: t("responses.received") }, { k: "sent", l: t("responses.sent") }].map((tb) => (
            <button key={tb.k} onClick={() => setDir(tb.k)}
              className={`px-5 py-2 rounded-full text-sm font-medium ${dir === tb.k ? `${theme.bg} text-white` : "text-gray-600"}`}>{tb.l}</button>
          ))}
        </div>

        <div className="mt-8 space-y-3">
          {items.length === 0 && <div className="text-center py-16 rounded-3xl bg-white border border-gray-100 text-gray-500">{t("responses.empty")}</div>}
          {items.map((it) => (
            <div key={it.id} className="rounded-2xl bg-white border border-gray-100 p-5 flex items-center gap-4 premium-shadow">
              <div className={`h-11 w-11 rounded-full ${theme.bg} text-white font-bold flex items-center justify-center`}>{it.from_user_name?.[0]}</div>
              <div className="flex-1">
                <div className="font-semibold text-gray-900">{it.from_user_name} <span className="text-gray-500 font-normal">is interested in</span> {it.listing_name}</div>
                <div className="text-xs text-gray-500 mt-1">{new Date(it.created_at).toLocaleString()} · Status: <b className={theme.text}>{it.status}</b></div>
              </div>
              {dir === "received" && it.status === "pending" && (
                <div className="flex gap-2">
                  <button data-testid={`response-accept-${it.id}`} onClick={() => action(it.id, "accepted")} className={`px-4 py-2 rounded-full ${theme.bg} text-white text-sm`}>{t("responses.accept")}</button>
                  <button data-testid={`response-reject-${it.id}`} onClick={() => action(it.id, "rejected")} className="px-4 py-2 rounded-full border border-gray-200 text-sm">{t("responses.reject")}</button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </AppShell>
  );
}
